import { PaymentMethodsWidgetContent } from './PaymentMethodsWidgetContent';
import type { LoadedInHousePaymentMethodsWidgetProps } from './usePaymentMethodsWidget';

export const InHousePaymentMethodsWidgetContent = ({
  data,
  handlers,
  hooks,
  isApplePayEnabled,
  disableApplePayAsNewPaymentMethod,
}: LoadedInHousePaymentMethodsWidgetProps) => {
  return (
    <PaymentMethodsWidgetContent
      data={data}
      handlers={handlers}
      hooks={hooks}
      isApplePayEnabled={isApplePayEnabled}
      disableApplePayAsNewPaymentMethod={disableApplePayAsNewPaymentMethod}
    />
  );
};
